import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import API_URL from "../config";

export default function Profil() {
  const navigate = useNavigate();
  const token = localStorage.getItem("token");
  const [user, setUser] = useState(null);
  const [username, setUsername] = useState("");
  const [photoUrl, setPhotoUrl] = useState("");
  const [uploading, setUploading] = useState(false);
  const [feedback, setFeedback] = useState("");
  const [error, setError] = useState("");

  useEffect(() => {
    if (!token) return navigate("/login");
    fetch(`${API_URL}/api/auth/me`, {
      headers: { Authorization: `Bearer ${token}` },
    })
      .then((r) => r.json())
      .then((data) => {
        setUser(data);
        setUsername(data.username || "");
        setPhotoUrl(data.photoUrl || "");
      });
  }, [token, navigate]);

  const handlePhotoUpload = async (e) => {
    const file = e.target.files[0];
    if (!file) return;
    setUploading(true);
    const formData = new FormData();
    formData.append("file", file);
    formData.append("upload_preset", "S5_profiles"); // ← ton preset Cloudinary
    try {
      const res = await fetch("https://api.cloudinary.com/v1_1/dnhyil8ak/image/upload", {
        method: "POST",
        body: formData,
      });
      const data = await res.json();
      setPhotoUrl(data.secure_url);
    } catch {
      setError("Erreur lors de l'upload de la photo.");
    } finally {
      setUploading(false);
    }
  };

  const handleSave = async () => {
    setFeedback("");
    setError("");
    try {
      const res = await fetch(`${API_URL}/api/auth/update-profile`, {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify({ username, photoUrl }),
      });
      const data = await res.json();
      if (!res.ok) return setError(data.message);
      localStorage.setItem("username", data.username);
      setFeedback("✅ Profil mis à jour !");
    } catch {
      setError("Erreur lors de la sauvegarde.");
    }
  };

  if (!user) return <div className="text-center mt-20" style={{ color: "var(--text-muted)" }}>Chargement...</div>;

  return (
    <div className="min-h-screen px-4 py-10" style={{ backgroundColor: "var(--bg)" }}>
      <div className="max-w-lg mx-auto">
        <h1 className="text-2xl font-bold mb-6" style={{ color: "var(--text)" }}>Mon profil</h1>

        <div className="rounded-xl border p-6 space-y-6"
             style={{ backgroundColor: "var(--bg-card)", borderColor: "var(--border)" }}>

          {/* Photo */}
          <div className="flex flex-col items-center gap-4">
            {photoUrl ? (
              <img src={photoUrl} alt="avatar"
                className="w-24 h-24 rounded-full object-cover border-4 border-blue-500"/>
            ) : (
              <div className="w-24 h-24 rounded-full bg-blue-600 flex items-center justify-center text-white text-3xl font-bold">
                {username?.[0]?.toUpperCase()}
              </div>
            )}
            <label className="cursor-pointer px-4 py-2 border rounded-lg text-sm font-medium hover:bg-gray-50 transition"
                   style={{ borderColor: "var(--border)", color: "var(--text)" }}>
              {uploading ? "Upload..." : "📷 Changer la photo"}
              <input type="file" accept="image/*" onChange={handlePhotoUpload} className="hidden"/>
            </label>
            <p className="text-xs text-center" style={{ color: "var(--text-muted)" }}>
                Ceci se voit dans votre compte, et peut être modifié à tout moment.
            </p>
          </div>

          {/* Infos identité (non modifiables) */}
          <div className="border rounded-lg p-4 space-y-2" style={{ borderColor: "var(--border)" }}>
            <p className="text-xs font-semibold uppercase tracking-wide mb-3" style={{ color: "var(--text-muted)" }}>
              Identité (non modifiable)
            </p>
            <div className="flex justify-between text-sm">
              <span style={{ color: "var(--text-muted)" }}>Prénom</span>
              <span style={{ color: "var(--text)" }}>{user.prenom}</span>
            </div>
            <div className="flex justify-between text-sm">
              <span style={{ color: "var(--text-muted)" }}>Nom</span>
              <span style={{ color: "var(--text)" }}>{user.nom}</span>
            </div>
            <div className="flex justify-between text-sm">
              <span style={{ color: "var(--text-muted)" }}>Date de naissance</span>
              <span style={{ color: "var(--text)" }}>
                {user.dateNaissance ? new Date(user.dateNaissance).toLocaleDateString("fr-FR") : "—"}
              </span>
            </div>
          </div>

          {/* Username modifiable */}
          <div>
            <label className="block text-sm font-medium mb-1" style={{ color: "var(--text-muted)" }}>
              Nom d'utilisateur
            </label>
            <input value={username} onChange={(e) => setUsername(e.target.value)}
              className="w-full border rounded-lg px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-blue-500"
              style={{ backgroundColor: "var(--bg)", borderColor: "var(--border)", color: "var(--text)" }}/>
          </div>

          {feedback && <p className="text-green-600 text-sm">{feedback}</p>}
          {error && <p className="text-red-500 text-sm">⚠️ {error}</p>}

          <button onClick={handleSave}
            className="w-full py-2.5 bg-blue-600 text-white font-medium rounded-lg hover:bg-blue-700 transition">
            Enregistrer
          </button>
        </div>
      </div>
    </div>
  );
}